/**
 * Shared platform-mode contract from AuthContext.
 * Route guards and auth state depend on these values for frontend access rules.
 */
export const PLATFORM_MODES = {
    TENANT_BASE: 'tenant_base',
    API_TENANT: 'api_tenant',
    ADMIN_MODE: 'Admin_Mode',
} as const;

export type PlatformMode = (typeof PLATFORM_MODES)[keyof typeof PLATFORM_MODES];

export const AUTH_CONTEXT_CLAIMS = {
    PLATFORM_MODE: 'platform_mode',
} as const;

export function isPlatformMode(value: unknown): value is PlatformMode {
    return typeof value === 'string' && (Object.values(PLATFORM_MODES) as string[]).includes(value);
}
